import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
    apiKey: 'AIzaSyAWMno_FHJzp-UNdPqt7_fsf1VlCGPA2Zg',
    authDomain: 'wooden-churner-db.firebaseapp.com',
    databaseURL: 'https://wooden-churner-db.firebaseio.com',
    projectId: 'wooden-churner-db',
    storageBucket: 'wooden-churner-db.appspot.com',
    messagingSenderId: '260340445481',
    appId: '1:260340445481:web:d46b9a07dea2c5fd2f8738',
    measurementId: 'G-DJBRGB69HN',
};

firebase.initializeApp(config);

export const createUserProfileDocument = async (userAuth, additionalData) => {
    if (!userAuth) return;

    const userRef = firestore.doc(`users/${userAuth.uid}`);

    const snapShot = await userRef.get();

    if (!snapShot.exists) {
        const { displayName, email } = userAuth;
        const createdAt = new Date();

        try {
            await userRef.set({
                displayName,
                email,
                createdAt,
                ...additionalData,
            });
        } catch (error) {
            console.log('Error creating user.', error.message);
        }
    }
    return userRef;
};

export const addOrdertoUser = async (user, cartItems, price, paymentId) => {
    const createdAt = new Date();
    firestore
        .collection('users')
        .doc(user?.id)
        .collection('orders')
        .doc(paymentId)
        .set(
            {
                cartItems: cartItems,
                amount: price,
                createdAt: createdAt,
            },
            { merge: true }
        );
};

export const getUserCartRef = async (userId) => {
    const cartsRef = firestore
        .collection('carts')
        .where('userId', '==', userId);
    const snapShot = await cartsRef.get();

    if (snapShot.empty) {
        const cartDocRef = firestore.collection('carts').doc();
        await cartDocRef.set({ userId, cartItems: [] });
        return cartDocRef;
    } else {
        return snapShot.docs[0].ref;
    }
};

export const addCollectionAndDocuments = async (
    collectionKey,
    objectsToAdd
) => {
    const collectionRef = firestore.collection(collectionKey);

    const batch = firestore.batch();
    objectsToAdd.forEach((obj) => {
        const newDocRef = collectionRef.doc();
        batch.set(newDocRef, obj);
    });

    return await batch.commit();
};

export const convertCollectionsSnapshotToMap = (collections) => {
    const transformedCollection = collections.docs.map((doc) => {
        const { title, items } = doc.data();

        return {
            routeName: encodeURI(title.toLowerCase()),
            id: doc.id,
            title,
            items,
        };
    });
    return transformedCollection.reduce((accumulator, collection) => {
        accumulator[collection.title.toLowerCase()] = collection;
        return accumulator;
    }, {});
};

export const getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged((userAuth) => {
            unsubscribe();
            resolve(userAuth);
        }, reject);
    });
};

export const auth = firebase.auth();
export const firestore = firebase.firestore();

export const googleProvider = new firebase.auth.GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
export const signInWithGoogle = () => auth.signInWithPopup(googleProvider);

export default firebase;
